<div id="managePopUp ">
  <div class="modal-header pd-xy-15">
    <h4 class="modal-title" id="modal-basic-title">{{authoringContentData?.scamProtection?.scamProtectionHeader}}</h4>
    <button type="button" class="close def-selected" aria-label="Close" (click)="onClickClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="switch-popup-text">
    <p>{{authoringContentData?.scamProtection?.scamPopupBody}}</p>
  </div>

  <div class="modal-footer">      
    <button type="button" class="btn secondary_btn only-bdr-btn" (click)="onClickClose()">{{authoringContentData?.scamProtection?.cancelCta}}</button>
    <button type="button" class="btn primary_btn order-sm-1" (click)="onClickPropceed()">{{authoringContentData?.scamProtection?.proceedCta}}</button>
  </div>
</div>